import styled from "styled-components";
import { Modal } from "antd";
import { Button } from "antd";

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Title = styled.p`
  font-size: 14px;
  color: #666;
  margin-bottom: 16px;
`;

export const CustomModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 10px;
  }

  .ant-modal-header {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: #12619C;
  }

  .ant-modal-title {
    color: #fff;
    font-weight: bold;
  }

  .ant-modal-close-x {
    color: #fff;
  }
`;


export const OperationList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const OperationItem = styled.div<{ isSelected: boolean, disabled?: boolean }>`
  padding: 12px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 12px;
  transition: all 0.2s ease;

  ${props => props.isSelected && `
    border-color: #2196F3;
    background: #E3F2FD;
  `}

  ${props => props.disabled && `
    cursor: not-allowed;
    opacity: 0.5;
  `}
`;

export const OperationSeqBadge = styled.div<{ isSelected: boolean }>`
  width: 32px;
  height: 32px;
  background: #12619C;
  color: white;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 13px;

  
   ${props => props.isSelected && `
    background: #1976D2;
  `}
`;

export const OperationDetail = styled.div`
  flex: 1;
`;

export const OperationName = styled.div`
  font-size: 13px;
  font-weight: 500;
  color: #333;
  margin-bottom: 3px;
`;

export const OperationMeta = styled.div`
  font-size: 11px;
  color: #777;
`;


export const ContainerFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 16px;
`;


export const ButtonRemove = styled(Button)`
  border-radius: 8px;
  border: 1px solid #d32f2f;
  color: #d32f2f;

  :hover {
    border: 1px solid #d32f2f !important;
    background-color: #ffebee;
    color: #d32f2f !important;
  }
  `